<style src="./view.scss" lang="scss"></style>
<template src="./view.html"></template>

<script>
import {
    defineComponent,
    onMounted,
    reactive,
    toRefs,
} from "@vue/composition-api";

export default defineComponent({
    setup(props, context) {
        return {
            ...useTable(context),
        };
    },
});

function useTable(context) {
    let { getProgressBusinesslist: getListApi, businessDel } = context.root.api;

    const state = reactive({
        tableData: [],
        currentPage: 1,
        pageSize: 50,
        total: 0,
        tableLoading: false,
        filterDrawer: false,
        filter: {}
    });

    // 分页大小改变
    const sizeChange = (pageSize) => {
        state.pageSize = pageSize;
        state.currentPage = 1;
        getList();
    };

    // 分页改变
    const currentChange = (currentPage) => {
        state.currentPage = currentPage;
        getList();
    };

    // 获取数据
    const getList = async function () {
        let params = {
            page: state.currentPage,
            limit: state.pageSize,
            type:1, //接口改版 新增type  1项目业务 2渠道分发 3作品投稿 4摄影投稿
        };

        if (!state.sortRule) {
            delete params.sort;
        }

        try {
            state.tableLoading = true;
            let data = await getListApi({...params, ...state.filter});
            if (data) {
                data.data.forEach((item) => {
                    let typesName = item.midTypesName || "";
                    item.midTypes = typesName.split(",").filter((type) => type);
                });
                state.tableData = data.data;
                state.total = data.total;
            }
        } finally {
            state.tableLoading = false;
        }
    };

    const operationClick = (type, item) => {
        context.root.$router.push({
            path: `business-process-edit/${type}`,
            query: { id: item.id },
        });
    };

    const delClick = async (item) => {
        await context.root.$confirm("此操作将永久删除该业务类型, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        });

        await businessDel({ id: item.id });
        context.root.$message.success("删除成功");
        getList();
    };

    const clearFilter = () => {
        state.filter = {}
        getList()
        state.filterDrawer = false
    }

    const filterOkClick = async () => {
        await getList()
        state.filterDrawer = false
    }

    onMounted(async () => {
        getList();
    });

    return {
        delClick,
        ...toRefs(state),
        currentChange,
        sizeChange,
        operationClick,
        clearFilter,
        filterOkClick
    };
}
</script>
